import Index from '@today_hot/index.vue'

export default {
  path: 'today-hot',
  component: Index,
  children: [
    {
      name: 'TodayHot',
      path: 'list',
      meta: {
        title: '热点寻龙'
      },
      component: () => import('@today_hot/today_hot.vue')
    },
    {
      name: 'TodayHotDetail',
      path: 'detail/:type/:id',
      meta: {
        title: '事件掘金'
      },
      component: () => import('@today_hot/event_detail.vue')
    },
    {
      name: 'TodayHotStock',
      path: 'stock',
      component: () => import('@today_hot/stock_detail.vue')
    },
    {
      name: 'TodayHotHistory',
      path: 'history',
      meta: {
        title: '历史事件'
      },
      component: () => import('@today_hot/history_list.vue')
    }
  ]
}
